import Vue from 'vue'
import Vuex from 'vuex'

import session from '@/common/stores/session';
import toasts from '@/common/stores/toasts';
import search from '@/common/stores/search';
import dashboard from '@/common/stores/dashboard';
import deals from '@/common/stores/deals';

Vue.use(Vuex);

export default new Vuex.Store({

    modules: {
        session,
        toasts,
        search,
        dashboard,
        deals
    }

});
